// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__GBVoi","inputWrap":"Table_inputWrap__8lK0_","col":"Table_col__3-DZC","bmiTooltip":"Table_bmiTooltip__2Qa0e"};